module.exports = __webpack_public_path__ + "img/index8.bf4212b8.jpg";